import './i18n'; // Initialize i18n before React
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { createLogger } from './lib/utils/logger';

const logger = createLogger('Main');

// Register Service Worker for PWA offline support (production only)
// In dev mode, vite-plugin-pwa handles this automatically
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        logger.info('Service Worker registered successfully', { scope: registration.scope });
      })
      .catch((error) => {
        logger.error('Service Worker registration failed', error);
      });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
